import { render, staticRenderFns } from "./Techniques.vue?vue&type=template&id=6f11f809"
import script from "./Techniques.vue?vue&type=script&lang=js"
export * from "./Techniques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports